<template>
    <van-card
        :key="item.id"
        :price="item.shop_price"
        :title="item.product_name + (item.product_versionname=='标准版'?'':item.product_versionname)"
        :thumb="item.product_imageurl"
         @click="goDetail(item)"
        class="prod-item">
        <div slot="tags" class="tags">
            <van-tag mark type="primary">{{ item.cls_name }}</van-tag>
            <van-tag mark type="primary">{{ item.cls1_name }}</van-tag>
        </div>
        <div slot="desc">
            <div>{{ item.brand_name }}</div>
            <div>{{ item.product_spc }}</div>
            <div>{{ item.product_barcode }}</div>
        </div>
    </van-card>
</template>

<script>
import { 
    Card,
    Tag
} from 'vant'
export default {
    name: 'ProdItem',
    props: ['item'],
    components: {
        [Card.name]: Card,
        [Tag.name]: Tag
    },
    methods: {
        goDetail(item) {
            const url = `/nt/directsell/${item.id}`
            console.log(url)
            this.$router.push(url)
        }
    }
}
</script>

<style lang="less" scoped>
.prod-item {
    .tags {
        .van-tag {
        margin-right: 4px;
        }
    }
}
</style>